export default {"src":"/_next/static/media/mu.3c9f5abb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};